<template>
  <div class="inline-flex items-center">
    <img
      src="@/assets/images/Logo.png"
      alt="SCANME Logo"
      class="w-auto object-contain"
      :class="{ 'h-5': !small, 'h-4': small }"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  small?: boolean
}

withDefaults(defineProps<Props>(), {
  small: false,
})
</script>
